module.exports = __webpack_public_path__ + "static/media/SofaAberto.f9373294.png";